export default {
  en: {
    'pages.manual-tax-codes-heading': 'Tax Code Mapping',
    'pages.manual-tax-codes.entity': 'Entity',
    'pages.manual-tax-codes.selected': 'Tax Codes selected',
    'pages.manual-tax-codes-continue': 'Continue',
  },
};
